// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"2b3172d6","325":"2b3172d6","699":"2b3172d6","715":"2b3172d6","785":"2b3172d6"}[chunkId] + ".chunk.css";
};